import Home from '@mui/icons-material/Home';

export const getDataForDaysRange = noOfDays => {
    const currentDate = new Date();
    return Math.floor(
        (currentDate - new Date().setDate(currentDate.getDate() - noOfDays)) / (1000 * 60 * 60 * 24)
    )
}

export const getDataForMonthsRange = noOfMonths => {
    const currentDate = new Date();
    return Math.floor(
        (currentDate - new Date().setMonth(currentDate.getMonth() - noOfMonths)) / (1000 * 60 * 60 * 24)
    );
}

export const getDataForYearsRange = noOfYears => {
    const currentDate = new Date();
    return Math.floor(
        (currentDate - new Date().setFullYear(currentDate.getFullYear() - noOfYears)) / (1000 * 60 * 60 * 24)
    );
}

// getUniqueMergedArray returns merged array which contains unique elements
export const getUniqueMergedArray = (firstArray, secondArray) => {
    const mergedArray = firstArray && [...firstArray, ...secondArray];
    const mergedUniqueArray = mergedArray?.filter((item, index) => mergedArray.indexOf(item) === index);
    return mergedUniqueArray;
}

// reset products array so that all checkboxes are unchecked when dialog box opens
export const resetCheckboxFromArray = (arrayToReset) => {
    const resetArray = arrayToReset.map((item) => {
        item.checked = false;
        return item;
    });
    return resetArray;
}

// Checks if user clicked on Infolistitem or Checkbox
export const isCheckboxOrInfolistClicked = (event, infoListItemClicked, item, name) => {
    if ((name === event?.target?.value) || (infoListItemClicked !== null && name === event?.target?.innerText)) {
        item.checked = event?.target?.checked || !infoListItemClicked;
        item.existingProduct = false;
    }
}


//Check for which device app is running
export const detectDevice = (width) => {
    if(width < 900){
        return 'mobile'
    }else if(width >= 900 && width < 1360){
        return 'tablet'
    }else{
        return 'desktop'
    }
}

export const extractRoutesFromArray = (arr, component, isProducts) => {
    if (arr?.length > 0) {
       const routesArr = arr.map((el) => {
            return {
                title: isProducts ? 'Products' : el?.name,
                route: isProducts ? `products/${el?.id}` : el?.link?.substring(1),
                component: component,
                icon: Home,
            };
        });
        return routesArr;
    }
};

export const generateKey = (message) => {
    return `translation:pages.toaster_messages.${message?.replace(/\s+/g, '_')}`;
};